import { Card, CardBody, CardHeader } from '@nextui-org/react'
import { FC } from 'react'
import { useTankInfoModalStore } from '../../../store/tankInfo/useTankInfoModalStore'
import { getTankPhysical } from '../../../types/mappers/tankInfo.mapper'
import '../../../styles/responsive.css'

export type TankVolumeCardProps = {
  tankId: string
}

export const TankVolumeCard: FC<TankVolumeCardProps> = ({ tankId }) => {
  const cardValues = useTankInfoModalStore((state) => state.cardValues)
  // Store에서 이미 계산된 물리적 데이터 사용
  const { volume, radius, depth } = cardValues
    ? getTankPhysical(cardValues)
    : { volume: undefined, radius: undefined, depth: undefined }

  return (
    <Card
      className="rounded-lg col-span-1 border border-tdpldarkgrey/60 bg-tdplbisque
      w-full md:w-auto h-auto md:h-[140px] p-4 md:p-[19px]"
      style={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }}
      data-card-type="tankVolume"
    >
      <CardHeader className="flex flex-row items-start m-0 p-0 mb-3 md:mb-4">
        <p className="text-tdpldarkgrey text-[1rem] font-bold">Tank Volume</p>
      </CardHeader>
      <CardBody className="m-0 p-0 flex flex-row items-end justify-between">
        <div className="flex flex-col">
          <p className="text-tdplprussian text-2xl md:text-[1.875rem] font-bold">
            {volume ?? '---'}
          </p>
          <p className="text-tdplprussian text-sm md:text-base">m³</p>
        </div>
        <div className="flex flex-col gap-1 text-sm md:text-base">
          <div className="flex items-center gap-2">
            <span className="text-tdplmiddlegrey font-semibold">RADIUS</span>
            <span className="text-tdpldarkgrey font-bold">
              {radius ?? '---'} <span className="text-tdplmiddlegrey">m</span>
            </span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-tdplmiddlegrey font-semibold">DEPTH</span>
            <span className="text-tdpldarkgrey font-bold">
              {depth ?? '---'} <span className="text-tdplmiddlegrey">m</span>
            </span>
          </div>
        </div>
      </CardBody>
    </Card>
  )
}

